export default {
  name: 'I`m JIE',
  login: {
    userName: 'username',
    password: 'password',
    message: 'Please input your',
    btn: 'Log in',
  },
  user: {
    name: 'admin',
  },
};
